module.exports = __webpack_public_path__ + "img/draggable.622d684e.svg";